import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TextMaskModule } from "angular2-text-mask";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Http, HttpModule, RequestOptions, XHRBackend } from "@angular/http";
import {
  MaterialModule,
  MdButtonModule,
  MdCardModule,
  MdSidenavModule,
  MdToolbarModule,
  MdTooltipModule,
} from "@angular/material";
import { StoreModule } from "@ngrx/store";
import "hammerjs";
import { EffectsModule } from "@ngrx/effects";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxPaginationModule } from "ngx-pagination";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import {
  ParticipationFormCleanupComponent,
  ParticipationFormComponent,
  ParticipationFormListComponent,
} from "./participation-form";
import { ClientRoutingModule } from "./app-routing.module";
import {
  AuthService,
  CampusService,
  CurrentUserResolve,
  ErrorService,
  FormLoaderService,
  FormValidationService,
  HttpService,
  LookupService,
  NotificationService,
  ParticipationFormCleanupResolve,
  ParticipationFormCodeResolve,
  ParticipationFormResolve,
  ParticipationFormService,
  PersonService,
  PrintService,
  SearchComponentService,
} from "./shared";
import {
  CAMPUS_REDUCER,
  ERROR_REDUCER,
  PARTICIPATION_FORM_LIST_REDUCER,
  PARTICIPATION_FORM_REDUCER,
  PERSON_REDUCER,
} from "./shared/reducer";
import { Effects } from "./shared/effects";
import { LoadingIndicatorComponent } from "./loading/loading.component";
import { OrderByPipe } from "./shared/sorting/orderBy.pipe";
import { ConfirmationComponent } from "./confirmation";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { ErrorComponent } from "./error/error.component";
import { ApprovalToolbarComponent } from "./approval-toolbar/approval-toolbar.component";
import { ProgramGeneratorComponent } from "./program-generator/program-generator.component";
import { AuthGuard, AppAdminGuard } from "./shared/guard";
import { StuckProgramsComponent } from "./stuck-programs";
import { StuckProgramsService } from "./shared/service";
import { FilterPipe } from "./shared/pipe";
import { PopoverModule } from "ng2-popover";
import { EmailSupplierComponent } from "./email-supplier/email-supplier.component";
import { DraftToolbarComponent } from "./draft-toolbar/draft-toolbar.component";
import { AmendmentHistoryComponent } from "./amendment-history/amendment-history.component";
import { RestrictedToolbarComponent } from "./restricted-toolbar/restricted-toolbar.component";
import { DatePipe } from "@angular/common";
import { NoRecordsComponent } from "./no-records/no-records.component";

// Cognito Config
import {
  FormComponent,
  FormSectionComponent,
  QuestionComponent,
  QuestionnaireControls,
  ErrorMessages,
} from "./form";
import { TypeaheadModule } from "ng2-bootstrap";
import { LaunchDarklyService } from "./launchdarkly.service";

@NgModule({
  declarations: [
    AppComponent,
    ParticipationFormComponent,
    ParticipationFormCleanupComponent,
    HomeComponent,
    ApprovalToolbarComponent,
    ProgramGeneratorComponent,
    ParticipationFormListComponent,
    LoadingIndicatorComponent,
    NoRecordsComponent,
    OrderByPipe,
    ConfirmationComponent,
    ConfirmationDialogComponent,
    ErrorComponent,
    FilterPipe,
    EmailSupplierComponent,
    DraftToolbarComponent,
    AmendmentHistoryComponent,
    RestrictedToolbarComponent,
    FormComponent,
    FormSectionComponent,
    QuestionComponent,
    QuestionnaireControls,
    ErrorMessages,
    StuckProgramsComponent,
  ],
  entryComponents: [ConfirmationDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    HttpModule,
    TextMaskModule,
    MdCardModule,
    MdSidenavModule,
    MdToolbarModule,
    MdButtonModule,
    MdTooltipModule,
    MaterialModule,
    ClientRoutingModule,
    PopoverModule,
    TypeaheadModule.forRoot(),
    StoreModule.provideStore({
      PARTICIPATION_FORM_REDUCER: PARTICIPATION_FORM_REDUCER,
      PARTICIPATION_FORM_LIST_REDUCER: PARTICIPATION_FORM_LIST_REDUCER,
      PERSON_REDUCER: PERSON_REDUCER,
      ERROR_REDUCER: ERROR_REDUCER,
      CAMPUS_REDUCER: CAMPUS_REDUCER,
    }),
    EffectsModule.run(Effects),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DatePipe,
    AuthService,
    HttpService,
    PersonService,
    PrintService,
    ParticipationFormService,
    CampusService,
    ErrorService,
    LaunchDarklyService,
    AuthGuard,
    AppAdminGuard,
    StuckProgramsService,
    NotificationService,
    FormValidationService,
    FormLoaderService,
    LookupService,
    SearchComponentService,
    ParticipationFormResolve,
    ParticipationFormCleanupResolve,
    ParticipationFormCodeResolve,
    CurrentUserResolve,
    {
      provide: HttpService,
      useFactory: httpServiceFactory,
      deps: [Http, XHRBackend, RequestOptions, AuthService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpServiceFactory(
  http: Http,
  backend: XHRBackend,
  options: RequestOptions,
  authService: AuthService
) {
  return new HttpService(http, backend, options, authService);
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/app.module.ts